import { createFileRoute } from '@tanstack/react-router';
import { listSearchSchema } from '@/lib/list-search-schema';
import Timesheets from '@/pages/Timesheets';

export const Route = createFileRoute('/_authenticated/timesheets')({
  validateSearch: listSearchSchema,
  component: Timesheets,
});
